import { render, staticRenderFns } from "./InviraRolesDelete.vue?vue&type=template&id=2b86919e&scoped=true"
import script from "./InviraRolesDelete.vue?vue&type=script&lang=js"
export * from "./InviraRolesDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b86919e",
  null
  
)

export default component.exports